const DEVELOPMENT_MODE = 'dev'

/**
 * Возвращает домен первого уровня текущего host.
 *
 * Для development всегда используется `ru`.
 *
 * @param hostname - hostname или host с портом
 * @param mode - режим запуска приложения
 * @returns домен первого уровня либо `undefined` для пустого hostname
 */
export const getCountryDomain = (hostname: string, mode?: string) => {
  if (mode === DEVELOPMENT_MODE) {
    return 'ru'
  }

  return hostname.split(':')[0]?.split('.').at(-1)
}
